import * as FC from "@fluentui/react-components";
import { getCurrentUser } from "../../services/login";
import { resolveEquipmentPermissions } from "../../services/equipment_service";

/**
 * 器材路由的读权限包装。
 *
 * 侧栏隐藏入口只挡住"看得见的路"，直接输入 /equipment 仍会挂载页面并发出请求，
 * 无权角色因此看到的是一串 403 提示、或者占位页的模块内容，而不是明确的拒绝。
 * 这里在挂载子组件之前就拦下来：不渲染页面、不发任何器材或用户请求。
 *
 * 后端策略（EquipmentRead/Write/Admin）与租户过滤才是安全边界，这里只负责给出一个诚实的界面。
 */
export const EquipmentRouteGuard = ({ children }) => {
    const permissions = resolveEquipmentPermissions(getCurrentUser());

    if (permissions.canRead) {
        return children;
    }

    return (
        <div style={{ padding: 24, maxWidth: 640 }}>
            <FC.MessageBar intent="error">
                <FC.MessageBarBody>
                    <FC.MessageBarTitle>无访问权限</FC.MessageBarTitle>
                    器材管理仅对管理员、外业作业员和质检角色开放。如需访问请联系管理员分配相应角色。
                </FC.MessageBarBody>
            </FC.MessageBar>
        </div>
    );
};

export default EquipmentRouteGuard;
